// Import dependencies
import { unsafeCSS, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-quick-action-duplicate' )
export class AutomatorBuilderPublishQuickActionDuplicate extends LitElement {
	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				${ _uo.utility.escHTML( wp.i18n.__( 'Duplicate recipe', 'uncanny-automator' ) ) }

				<uo-button
					slot="target"
					size="small"
					color="transparent"

					href=${ UncannyAutomator._recipe.miscellaneous.url_duplicate_recipe }

					needs-confirmation
					confirmation-content=${ _uo.utility.escHTML( wp.i18n.__( 'Are you sure you want to duplicate this recipe?', 'uncanny-automator' ) ) }
					confirmation-button-label=${ _uo.utility.escHTML( wp.i18n.__( 'Duplicate recipe', 'uncanny-automator' ) ) }
				>
					<uo-icon id="copy"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}